module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/cross-orange-sign-10bd46ab.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/cross-orange-sign.svg
// module id = ./app/web/src/assets/cross-orange-sign.svg
// module chunks = 0